import { render } from "./logoutResPopup.vue?vue&type=template&id=3c0eac8f&scoped=true"
import script from "./logoutResPopup.vue?vue&type=script&lang=js"
export * from "./logoutResPopup.vue?vue&type=script&lang=js"

import "./logoutResPopup.vue?vue&type=style&index=0&id=3c0eac8f&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0eac8f"]])

export default __exports__